// Owner resolution for a quote — single source of truth for the admin.
//
// Canonical convention (mirrors the API): the record owner is the
// customer-level participation (participationType empty: "", null or
// undefined) with the LOWEST `position`. It must NOT be required to sit
// exactly at position 0 — a customer assigned through the Magento guest→login
// flow (quote created Ownerless as `store`, customer opens the share link as a
// guest and then logs in) can land at a non-zero position. Requiring
// position === 0 made the quote detail render "Sin dueño" even though the
// list showed the owner correctly.
//
// Operators (participationType "store"/"seller") are excluded by the empty-type
// filter, so the quote stays Ownerless until a real customer is assigned.
//
// Backend references (same convention):
//   - src/quotes/services/quote-checkout.service.ts
//       (filter empty participationType, sort by position, take [0])
//   - src/quotes/listeners/quote-relation-creation.listener.ts
//       (participationType='' ordered by position ASC)
export interface QuoteParticipation {
  position?: number | string | null;
  participationType?: string | null;
  [key: string]: any;
}

export const isCustomerParticipation = (p: QuoteParticipation): boolean =>
  (p?.participationType ?? "") === "";

export const resolveOwnerParticipation = <T extends QuoteParticipation>(
  participations: T[] = [],
): T | null =>
  (participations || [])
    .filter(isCustomerParticipation)
    .sort((a, b) => (Number(a.position) || 0) - (Number(b.position) || 0))[0] ??
  null;
